export const standardTheme = {
    backgroundColor:'#d8d8e8',
    borderTop:'3px solid #f0f0f0',
    borderRight:'3px solid #a8b0c0',
    borderBottom:'3px solid #a8b0c0',
    borderLeft:'3px solid #f0f0f0',
    boxShadow:'0 0 0 1px #506880',
    textShadow: '2px 2px #b8b8b8'
};

export const megaTheme = {
    backgroundColor:'#a8e8e8',
    borderTop:'3px solid #e8f0f8',
    borderRight:'3px solid #78b8b8',
    borderBottom:'3px solid #78b8b8',
    borderLeft:'3px solid #e8f0f8',
    boxShadow:'0 0 0 1px #508098',
    textShadow: '2px 2px #88c8c0'
}

export const gigaTheme = {
    backgroundColor:'#f0c8e0',
    borderTop:'3px solid #f8f0f0',
    borderRight:'3px solid #d090a0',
    borderBottom:'3px solid #d090a0',
    borderLeft:'3px solid #f8f0f0',
    boxShadow:'0 0 0 1px #883050',
    textShadow: '2px 2px #e0a0c8'
}

export const darkTheme = {
    backgroundColor:'#b088d0',
    borderTop:'3px solid #e0d0f8',
    borderRight:'3px solid #8860a8',
    borderBottom:'3px solid #8860a8',
    borderLeft:'3px solid #e0d0f8',
    boxShadow:'0 0 0 1px #303858',
    textShadow: '2px 2px #9870b8'
    
}